import React from 'react';
import { Form } from 'semantic-ui-react';

import PhoneInput, {
  Props as PhoneInputProps,
} from 'src/components/custom/PhoneInput';

export type Props = {
  label?: string;
  error?: string;
} & PhoneInputProps;

const EditorField: React.FC<Props> = (props) => {
  const { label, error, ...rest } = props;

  return (
    <Form.Field>
      <label>{label}</label>
      <PhoneInput {...rest} />
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default EditorField;
